module.exports = __webpack_public_path__ + "static/media/loader.77c76ae7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/loader.gif
// module id = 614
// module chunks = 0